import { Extension, InputRule } from '@tiptap/core';
import { Slice, Fragment, Node } from 'prosemirror-model';
import { Plugin } from 'prosemirror-state';

const replaceNbsp = (text: string): string => {
  return text
    .replace(/\u00A0/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/&nbsp/g, ' ');
};

export const NbspReplacer = Extension.create({
  name: 'replaceNbsp',

  addInputRules() {
    const nbspInputRule = new InputRule({
      find: /&nbsp;?/,
      handler: ({ state, range }) => {
        const { tr } = state;
        tr.insertText(' ', range.from, range.to);
      },
    });

    return [nbspInputRule];
  },

  addProseMirrorPlugins() {
    return [
      new Plugin({
        props: {
          transformPastedText: (text) => {
            return replaceNbsp(text);
          },
          transformPasted: (slice: Slice) => {
            const { schema } = this.editor;

            const transformFragment = (fragment: Fragment): Fragment => {
              const children: Array<Node> = [];
              fragment.forEach((node) => {
                let newNode = node;
                if (node.isText && node.text) {
                  const replacedText = replaceNbsp(node.text);
                  newNode = schema.text(replacedText, node.marks);
                } else if (node.content.size > 0) {
                  newNode = node.copy(transformFragment(node.content));
                }
                children.push(newNode);
              });
              return Fragment.fromArray(children);
            };

            return new Slice(transformFragment(slice.content), slice.openStart, slice.openEnd);
          },
        },
      }),
    ];
  },
});
